import { Button } from 'src/components/ui/button';
import { useEffect, useState } from 'react';
import { RadioGroup, RadioGroupItem } from 'src/components/ui/radio-group';
import { clsx } from 'clsx';
import { useAppSelector, useAppDispatch } from 'src/store';
import { setPromptType } from 'src/store/slices/onboardingSlice';
import { PATH_ONBOARDING } from 'src/constants/spa-routes';
import { ProductsType } from 'src/constants/products';
import { useNavigate } from 'react-router-dom';
import { useLoader } from 'src/provider/LoaderProvider';
import { API_VERSION } from 'src/constants/api-routes';
import { getApiVersion } from 'src/utils/apiVersion';

export const OnboardingStep3 = () => {
  const { promptType } = useAppSelector((s) => s.onboardingSlice);
  const [value, setValue] = useState(promptType || 'system');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const loader = useLoader();
  const version = getApiVersion();
  const isV2 = version === API_VERSION.V2;

  useEffect(() => {
    if (isV2) {
      dispatch(setPromptType('system'));
      next();
    }

    loader.hide();
  }, []);

  useEffect(() => {
    if (promptType && promptType !== value) {
      setValue(promptType);
    }
  }, [promptType]);

  useEffect(() => {
    if (value && promptType !== value) {
      dispatch(setPromptType(value));
    }
  }, [value]);

  const back = () => {
    navigate(`${PATH_ONBOARDING.ROOT}/2?type=${ProductsType.customer}`, { replace: true });
  };

  const next = () => {
    navigate(`${PATH_ONBOARDING.ROOT}/4?type=${ProductsType.customer}`, { replace: true });
  };

  return (
    <div className={'w-full max-w-[550px]'}>
      <div className={'flex flex-col gap-[5px] px-[50px] py-1'}>
        <div className={'flex flex-col w-[455px]'}>
          <RadioGroup
            onValueChange={(next) => (next === 'system' || next === 'manual') && setValue(next)}
            value={value}
            className="flex flex-col space-y-1"
          >
            <label
              htmlFor="system"
              className={'flex flex-col w-full gap-1.5 group/label hover:cursor-pointer'}
            >
              <div className={clsx('flex items-center space-x-5 space-y-0')}>
                <RadioGroupItem value={'system'} id="system" />
                <p className="font-medium text-base text-ebony opacity-70 group-hover/label:opacity-100 transition">
                  Use System Prompt Builder 🏗️
                </p>
              </div>
              <div className={'pl-9'}>
                <p className={'text-ebony_opacity_50 text-sm font-medium'}>
                  Create the AI system prompt through a guided, step-by-step flow with built-in best
                  practices. Ideal if you want a fast, reliable setup.
                </p>
              </div>
            </label>

            <label
              htmlFor="manual"
              className={'flex flex-col w-full gap-1.5 group/label hover:cursor-pointer'}
            >
              <div className={clsx('flex items-center space-x-5 space-y-0')}>
                <RadioGroupItem value={'manual'} id="manual" />
                <p className="font-medium text-base text-ebony opacity-70 group-hover/label:opacity-100 transition">
                  Write System Prompt Manually ✍️
                </p>
              </div>
              <div className={'pl-9'}>
                <p className={'text-ebony_opacity_50 text-sm font-medium'}>
                  Start with a blank editor and craft the AI system prompt line by line. Ideal if
                  you prefer full control and already know how to structure effective prompts.
                </p>
              </div>
            </label>
          </RadioGroup>
        </div>
      </div>
      <div className={'mt-5 flex items-center justify-center gap-5 px-[50px]'}>
        <div className={'flex flex-col w-full items-center justify-center gap-5'}>
          <Button onClick={next} className="w-full py-6 font-semibold">
            <p>Continue</p>
          </Button>
          <button
            type="button"
            onClick={back}
            className={'text-[#3F60B3] text-xs font-medium cursor-pointer hover:underline'}
          >
            ← Back
          </button>
        </div>
      </div>
    </div>
  );
};
